import { render, staticRenderFns } from "./project-detail.vue?vue&type=template&id=6c4d43fc"
import script from "./project-detail.vue?vue&type=script&lang=js"
export * from "./project-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports